import React from 'react';
import { colors } from '@styleseat/brand';

type SecurityShieldOkIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SecurityShieldOkIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: SecurityShieldOkIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23C6 20.3271 3 17.6604 3 15V5C3 4.23241 3.2946 4.05401 4.10993 3.56029L4.10993 3.56029C4.35679 3.4108 4.65139 3.23241 5 3C5.16179 2.89214 8.56321 1 12 1C14.9952 1 17.5 2 19 3C19.3486 3.23241 19.6432 3.4108 19.8901 3.56029C20.7054 4.05401 21 4.23241 21 5C21.0197 5.21723 21.01 9.83711 21.0038 12.7947C21.0017 13.8033 21 14.6186 21 15C21 17.6667 18 20.3333 12 23ZM19 15C19 14.7697 19.0006 14.3838 19.0018 13.7547L19.0059 11.8014C19.0072 11.1695 19.0082 10.6272 19.009 10.1098C19.0127 7.87764 19.0117 5.96182 19.0096 5.36928L18.8722 5.28403C18.5488 5.08342 18.1274 4.82194 17.8906 4.6641C16.4143 3.67992 14.2602 3 12 3C9.83809 3 7.02864 4.05128 6.1094 4.6641C5.87264 4.82194 5.45117 5.08341 5.1278 5.28402L5.12779 5.28403L5 5.36333V15C5 16.5085 7.22911 18.5687 12.0009 20.802C16.7722 18.5737 19 16.5142 19 15ZM15.2929 8.29289L11 12.5858L8.70711 10.2929L7.29289 11.7071L11 15.4142L16.7071 9.70711L15.2929 8.29289Z"
      fill={color}
    />
  </svg>
);
